import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_80abb622 from 'nuxt_plugin_plugin_80abb622' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_plugin_3de315f4 from 'nuxt_plugin_plugin_3de315f4' // Source: ./log-rocket/plugin.js (mode: 'all')
import nuxt_plugin_vuewebcam_15eb6b3c from 'nuxt_plugin_vuewebcam_15eb6b3c' // Source: ./vue-web-cam.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_6d7e0a9d from 'nuxt_plugin_cookieuniversalnuxt_6d7e0a9d' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vsanitize_6d729b63 from 'nuxt_plugin_vsanitize_6d729b63' // Source: ./v-sanitize.js (mode: 'all')
import nuxt_plugin_workbox_294200d1 from 'nuxt_plugin_workbox_294200d1' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_d70c3238 from 'nuxt_plugin_metaplugin_d70c3238' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_request_281e2659 from 'nuxt_plugin_request_281e2659' // Source: ../plugins/request (mode: 'client')
import nuxt_plugin_save_6a8631f3 from 'nuxt_plugin_save_6a8631f3' // Source: ../plugins/save (mode: 'client')
import nuxt_plugin_chartkick_63c74724 from 'nuxt_plugin_chartkick_63c74724' // Source: ../plugins/chartkick (mode: 'client')
import nuxt_plugin_flatpickr_2d9eb1e2 from 'nuxt_plugin_flatpickr_2d9eb1e2' // Source: ../plugins/flatpickr (mode: 'client')
import nuxt_plugin_globalComponents_97da3ae2 from 'nuxt_plugin_globalComponents_97da3ae2' // Source: ../plugins/globalComponents (mode: 'all')
import nuxt_plugin_toolkit_ba4a3bf0 from 'nuxt_plugin_toolkit_ba4a3bf0' // Source: ../plugins/toolkit (mode: 'client')
import nuxt_plugin_serviceWorkerUpdater_77b7572c from 'nuxt_plugin_serviceWorkerUpdater_77b7572c' // Source: ../plugins/serviceWorkerUpdater (mode: 'client')
import nuxt_plugin_firebaseMessaging_62a43c07 from 'nuxt_plugin_firebaseMessaging_62a43c07' // Source: ../plugins/firebaseMessaging (mode: 'client')
import nuxt_plugin_vueImageUploader_8a4dbf0e from 'nuxt_plugin_vueImageUploader_8a4dbf0e' // Source: ../plugins/vueImageUploader (mode: 'client')
import nuxt_plugin_vMask_333e2268 from 'nuxt_plugin_vMask_333e2268' // Source: ../plugins/vMask (mode: 'client')
import nuxt_plugin_analytics_0ae804d0 from 'nuxt_plugin_analytics_0ae804d0' // Source: ../plugins/analytics (mode: 'client')
import nuxt_plugin_date_6a7f6024 from 'nuxt_plugin_date_6a7f6024' // Source: ../plugins/date (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - OSHTrak Business","title":"App","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, viewport-fit=cover,user-scalable=0"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fimages\u002Ficons\u002Flogo.png?v=6.0.2-5efb1d7-5"},{"rel":"apple-touch-icon","href":"images\u002Ficons\u002Fapple-touch-icon.png?v=6.0.2-5efb1d7-5","sizes":"512x512"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-2048-2732.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-2732-2048.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1668-2388.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-2388-1668.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1536-2048.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-2048-1536.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1668-2224.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-2224-1668.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1620-2160.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-2160-1620.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1284-2778.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-2778-1284.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1170-2532.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-2532-1170.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1125-2436.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-2436-1125.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1242-2688.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-2688-1242.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-828-1792.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1792-828.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1242-2208.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-2208-1242.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-750-1334.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1334-750.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-640-1136.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"images\u002Fsplashscreen\u002Fapple-splash-1136-640.jpg?v=6.0.2-5efb1d7-5","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.gstatic.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fbeta-api.forestry.oshtrak.com","crossorigin":true},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_80abb622 === 'function') {
    await nuxt_plugin_plugin_80abb622(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_3de315f4 === 'function') {
    await nuxt_plugin_plugin_3de315f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuewebcam_15eb6b3c === 'function') {
    await nuxt_plugin_vuewebcam_15eb6b3c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_6d7e0a9d === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_6d7e0a9d(app.context, inject)
  }

  if (typeof nuxt_plugin_vsanitize_6d729b63 === 'function') {
    await nuxt_plugin_vsanitize_6d729b63(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_294200d1 === 'function') {
    await nuxt_plugin_workbox_294200d1(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_d70c3238 === 'function') {
    await nuxt_plugin_metaplugin_d70c3238(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_request_281e2659 === 'function') {
    await nuxt_plugin_request_281e2659(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_save_6a8631f3 === 'function') {
    await nuxt_plugin_save_6a8631f3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chartkick_63c74724 === 'function') {
    await nuxt_plugin_chartkick_63c74724(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_flatpickr_2d9eb1e2 === 'function') {
    await nuxt_plugin_flatpickr_2d9eb1e2(app.context, inject)
  }

  if (typeof nuxt_plugin_globalComponents_97da3ae2 === 'function') {
    await nuxt_plugin_globalComponents_97da3ae2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toolkit_ba4a3bf0 === 'function') {
    await nuxt_plugin_toolkit_ba4a3bf0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_serviceWorkerUpdater_77b7572c === 'function') {
    await nuxt_plugin_serviceWorkerUpdater_77b7572c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_firebaseMessaging_62a43c07 === 'function') {
    await nuxt_plugin_firebaseMessaging_62a43c07(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueImageUploader_8a4dbf0e === 'function') {
    await nuxt_plugin_vueImageUploader_8a4dbf0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vMask_333e2268 === 'function') {
    await nuxt_plugin_vMask_333e2268(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_0ae804d0 === 'function') {
    await nuxt_plugin_analytics_0ae804d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_date_6a7f6024 === 'function') {
    await nuxt_plugin_date_6a7f6024(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
